const state = {
  face: {
    api_key: 'QKHHEk_Ur0oEa6QmG7PGLf1J_lTKx_Oq',
    api_secret: 'yzi6B7T0fuaPcWgAXPbS4QFHRMewJjJV'
  }
}

export default {
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js